import { Button, CardHeader, Stack } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "../../services/localization-service/i18n";
import ActionMenu from "../action-menu/ActionMenu";
import { ActionMenuItem } from "../action-menu/ActionMenuItem";

export type StepMenuLandingCardHeaderProps = {
    editButtonLabel?: string | null;
    editEnabled?: boolean;
    editCallToAction?: boolean;
    duplicateEnabled?: boolean;
    deleteEnabled?: boolean;
    renameEnabled?: boolean;
    hideEdit?: boolean;

    onEdit?: () => void;
    onDuplicate?: () => void;
    onDelete?: () => void;
    onRename?: () => void;

    title?: React.ReactNode;
    avatar?: React.ReactNode;
};

export default function StepMenuLandingCardHeader({
    editButtonLabel = i18n.t("stepMenu.editSection") as string,
    editEnabled = false,
    editCallToAction = false,
    duplicateEnabled = false,
    deleteEnabled = false,
    renameEnabled = false,
    hideEdit,
    onEdit,
    onDuplicate,
    onDelete,
    onRename,
    title,
    avatar

}: StepMenuLandingCardHeaderProps) {
    const { t } = useTranslation();

    const actionItems = new Array<ActionMenuItem>();

    if (onDuplicate) {
        actionItems.push({
            label: t("actions.duplicate"),
            onClick: () => {
                onDuplicate && onDuplicate();
            },
            disabled: !duplicateEnabled
        });
    }

    if (onDelete) {
        actionItems.push({
            label: t("actions.delete"),
            onClick: () => {
                onDelete && onDelete();
            },
            disabled: !deleteEnabled
        });
    }

    if (onRename) {
        actionItems.push({
            label: t("actions.rename"),
            onClick: () => {
                onRename && onRename();
            },
            disabled: !renameEnabled
        });
    }

    return (
        <CardHeader
            sx={{
                padding: 1
            }}
            title={title}
            avatar={avatar}
            action={
                <Stack direction="row">
                    {!hideEdit && <Button
                        disabled={!editEnabled}
                        color={editCallToAction ? "secondary" : "primary"}
                        onClick={() => onEdit && onEdit()}>
                        {editButtonLabel}
                    </Button>
                    }
                    <ActionMenu actionItems={actionItems} />
                </ Stack>
            }
        />
    );
}
